import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Play, MoreVertical, Upload, Plus } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../../components/ui/Select';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../components/ui/DropdownMenu';
import { riveCollections, riveFiles } from '../../src/seed';
export function RiveCollectionDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const collection = riveCollections.find(c => c.id === id);
  const files = riveFiles.filter(f => f.collectionIds.includes(id || ''));
  if (!collection) {
    return <Card data-id="element-544">
        <CardHeader data-id="element-545">
          <CardTitle data-id="element-546">Collection not found</CardTitle>
        </CardHeader>
      </Card>;
  }
  return <div className="space-y-6" data-id="element-547">
      <div data-id="element-548">
        <Button variant="ghost" size="sm" className="-ml-3 mb-2 text-muted-foreground" onClick={() => navigate('/rive/collections')} data-id="element-549">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-550" />
          Collections / {collection.name}
        </Button>
        <div className="flex items-start justify-between" data-id="element-551">
          <div data-id="element-552">
            <h1 className="text-3xl font-bold tracking-tight mb-2" data-id="element-553">
              {collection.name}
            </h1>
            <div className="flex items-center gap-2" data-id="element-554">
              <Badge variant="secondary" data-id="element-555">Manual</Badge>
              <span className="text-sm text-muted-foreground" data-id="element-556">
                {files.length} files
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-557">
            <Button variant="outline" data-id="element-558">
              <Upload className="mr-2 h-4 w-4" data-id="element-559" />
              Upload .riv
            </Button>
            <Button data-id="element-560">
              <Plus className="mr-2 h-4 w-4" data-id="element-561" />
              Create animation
            </Button>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2" data-id="element-562">
        <Input placeholder="Filter..." className="max-w-xs" data-id="element-563" />
        <Select defaultValue="newest" data-id="element-564">
          <SelectTrigger className="w-[180px]" data-id="element-565">
            <SelectValue placeholder="Sort by" data-id="element-566" />
          </SelectTrigger>
          <SelectContent data-id="element-567">
            <SelectItem value="newest" data-id="element-568">Newest first</SelectItem>
            <SelectItem value="oldest" data-id="element-569">Oldest first</SelectItem>
            <SelectItem value="name" data-id="element-570">Name A-Z</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-571">
        {files.map(file => <Card key={file.id} className="cursor-pointer hover:shadow-md transition-shadow group" onClick={() => navigate(`/rive/library/${file.id}`)} data-id="element-572">
            <CardContent className="p-4 flex items-center gap-4" data-id="element-573">
              <div className="size-20 aspect-square bg-muted rounded-lg flex items-center justify-center shrink-0" data-id="element-574">
                <Play className="h-8 w-8 text-muted-foreground/40" data-id="element-575" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-576">
                <div className="flex items-start justify-between" data-id="element-577">
                  <h3 className="font-semibold text-lg truncate mb-1" data-id="element-578">
                    {file.name}
                  </h3>
                  <DropdownMenu data-id="element-579">
                    <DropdownMenuTrigger asChild onClick={e => e.stopPropagation()} data-id="element-580">
                      <Button variant="ghost" size="icon" className="h-8 w-8 -mr-2 -mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-581">
                        <MoreVertical className="h-4 w-4" data-id="element-582" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" data-id="element-583">
                      <DropdownMenuItem onClick={e => e.stopPropagation()} data-id="element-584">
                        Edit
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={e => e.stopPropagation()} className="text-destructive" data-id="element-585">
                        Delete
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
                <p className="text-sm text-muted-foreground mb-2" data-id="element-586">
                  {file.sizeKb} KB · {file.eventCount} events · {file.useCase}
                </p>
                <div className="flex gap-2" data-id="element-587">
                  <Badge variant={file.hasTimeline ? 'default' : 'secondary'} className={file.hasTimeline ? 'bg-green-600 hover:bg-green-700' : ''} data-id="element-588">
                    Timeline
                  </Badge>
                  <Badge variant={file.isPublished ? 'default' : 'secondary'} className={file.isPublished ? 'bg-green-600 hover:bg-green-700' : ''} data-id="element-589">
                    Published
                  </Badge>
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}